import { date } from "colbi_web_ui/lib/utils";
import { adjustForTimezone } from "../../utils/convertUtils";
import { displayValue } from "./utils/mapperUtils";

const formatExpirationDate = (expirationDate) => {
    if (!expirationDate) {
        return "N/A";
    }
    return displayValue(date(adjustForTimezone(expirationDate).getTime()));
};

const mapCard = (json) => {
    const { name, packageName, active, expirationDate } = json;
    return [
        [{ labels: ["name"], value: displayValue(name), type: "string" }],
        [
            {
                labels: ["expiration_date"],
                value: formatExpirationDate(expirationDate),
                type: "string",
            },
        ],
        [{ labels: ["package_name"], value: displayValue(packageName), type: "string" }],
        [
            {
                labels: ["active"],
                value: {
                    customComponent: "ActiveStatus",
                    active,
                },
                type: "customComponent",
            },
        ],
    ];
};

const mapper = (json, card, details) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Organization Name"],
        align: "left",
        columnName: "name",
        sortable: true,
    },
    { label: ["Expiration Date"], align: "left" },
    {
        label: ["Package Name"],
        align: "left",
        columnName: "profiles.name",
        sortable: true,
    },
    { label: ["Active"], align: "center", type: "customComponent" },
];

const organizationadministrationMapper = {
    map: mapper,
    header,
};

export default organizationadministrationMapper;
